import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { copyToClipboard, getFullURL } from './shareUtils';

export const CopyTextButton = ({ text, onCopied, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const [isCopied, setIsCopied] = useState(false);
  const shareUrl = getFullURL();

  const handleCopy = () => {
    copyToClipboard(text || '')
      .then(() => {
        setIsCopied(true);
        if (onCopied) {
          onCopied();
        }
        setTimeout(() => {
          setIsCopied(false);
        }, 5000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };

  const copyLabel = isCopied
    ? intl.formatMessage({ id: 'ShareActions.copied', defaultMessage: 'Copied! Ready to paste!' })
    : intl.formatMessage({ id: 'ShareActions.copyText', defaultMessage: 'Copy text' });

  return (
    <ShareButtonBase
      icon={<ContentCopyIcon />}
      label={copyLabel}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleCopy}
      {...rest}
    />
  );
};

CopyTextButton.propTypes = {
  text: PropTypes.string,
  onCopied: PropTypes.func,
  sharedItemName: PropTypes.string,
  shareOrigin: PropTypes.string,
};

CopyTextButton.defaultProps = {
  text: '',
  onCopied: null,
};
